import { render, staticRenderFns } from "./RaporOzetKarti.vue?vue&type=template&id=6356b49a&scoped=true"
import script from "./RaporOzetKarti.vue?vue&type=script&lang=ts"
export * from "./RaporOzetKarti.vue?vue&type=script&lang=ts"
import style0 from "./RaporOzetKarti.vue?vue&type=style&index=0&id=6356b49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356b49a",
  null
  
)

export default component.exports